// src/features/support/SupportPage.tsx
import { GlassCard } from '../../app/components/ui/GlassCard';
import { TicketList } from './components/TicketList';
import { useSupportTickets } from './hooks/useSupportTickets';

export function SupportPage() {
  const { tickets, loading, error } = useSupportTickets();

  return (
    <div className="flex flex-col gap-4 sm:gap-5">
      <div className="flex flex-col gap-1">
        <h1 className="text-lg font-semibold text-[var(--vania-colors-text-primary,#f5f6fa)]">
          پشتیبانی
        </h1>
        <p className="text-sm text-[var(--vania-colors-text-secondary,#a3aab8)]">
          فهرست تیکت‌های پشتیبانی اخیر شما.
        </p>
      </div>

      {loading ? (
        <GlassCard>
          <p className="text-sm text-[var(--vania-colors-text-secondary,#a3aab8)]">
            در حال دریافت تیکت‌ها...
          </p>
        </GlassCard>
      ) : error ? (
        <GlassCard>
          <p className="text-sm text-rose-400">{error}</p>
        </GlassCard>
      ) : (
        <GlassCard noPadding>
          <TicketList tickets={tickets} />
        </GlassCard>
      )}
    </div>
  );
}
